// Support to IE 11
require("babel-polyfill");

// Initialize Sentry (must be first)
import { initSentry } from './config/sentry';
initSentry();

// Global Configurations
require ('./config');

// Functions
require ('./functions');